import favoriteHeartFactory from '@finn-no/favorite-heart-component';
import { useConfig } from 'shared/config/ConfigContext';

type FavoriteButtonProps = {
    itemId: number;
    wrapperClassName?: string;
    loginId?: string | null;
};

export const FavoriteButton = ({ itemId, wrapperClassName, loginId }: FavoriteButtonProps) => {
    const { favouriteBaseUri } = useConfig();
    const FavoriteComponent = favoriteHeartFactory({ userId: loginId ?? undefined, baseUri: favouriteBaseUri });

    return (
        <div className={wrapperClassName} data-testid="favoriteButton">
            <FavoriteComponent itemType="Ad" variant="heart-on-image" itemId={itemId} isMobile={false} />
        </div>
    );
};
